import { Typography } from "@mui/material";
import { AmazonWadmLastImport } from "generated-graphql/graphql";
import { formatDateLikeForDisplay, prettyPrintDateMed } from "util/dates";

function formatLastImport({ importedAt, periodStart, periodEnd }: AmazonWadmLastImport): string {
  const lastImport = `Last import: ${prettyPrintDateMed(importedAt)}`;
  if (!periodStart || !periodEnd) return lastImport;
  const month = (date: string) => formatDateLikeForDisplay(date, { format: "LLL yyyy" });
  const start = month(periodStart);
  const end = month(periodEnd);
  const period = start === end ? start : `${start} – ${end}`;
  return `${lastImport} · covers ${period}`;
}

export function WadmLastImport({
  lastImport,
}: {
  lastImport: AmazonWadmLastImport | null | undefined;
}) {
  if (!lastImport) return null;
  return (
    <Typography variant="body2" color="text.secondary">
      {formatLastImport(lastImport)}
    </Typography>
  );
}
